<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :key="pageKey"
    :baseView="baseView"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentDynamic
        title="Customer"
        :baseView="baseView"
        :primaryLabel="model.CustomerName"
        :secondaryLabel="model.CustomerCode"
        recordType="Customer"
        v-if="model.CustomerCode"
      />
    </template>

    <div class="css-v2 gc-master-screen">
      <DxToolbar class="view-toolbar">
        <DxItem
          :options="toolbar.edit"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode == 'review'"
        />
        <DxItem
          :options="toolbar.save"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
          v-if="baseView.mode != 'review'"
        />
      </DxToolbar>
      <div class="view-card responsive-paddings">
        <!-- <div>{{model}}</div> -->
        <form>
          <DxForm
            :form-data.sync="model"
            :read-only="false"
            :show-colon-after-label="false"
            :show-required-mark="false"
            :show-validation-summary="false"
            :validation-group="formsConfig.validationGroup"
            :col-count-by-screen="formsConfig.colCountByScreen"
            label-location="left"
            :items="items"
            :ref="'header-form'"
            @content-ready="onFormContentReady"
          >
            <!-- :customizeItem="customizeItem" -->
            <template #agentTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{ data.Name }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
            <template #accrualAccountTemplate="{ data }">
              <div class="custom-auto-complete">
                <span class="auto-complete-primary">{{
                  data.Description
                }}</span>
                <span class="auto-complete-secondary">{{ data.Code }}</span>
              </div>
            </template>
          </DxForm>
        </form>
      </div>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import validationEngine from "devextreme/ui/validation_engine";

import { AgentSupplierService } from "../../_services/api/accounts/agent-supplier.service";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerAgentService } from "../../_services/api/customers/customer-agent.service";
import { GLChartService } from "../../_services/api/gl/gl-chart.service";
import { FeatureStorage } from "../../_services/storage";

export default {
  props: {},
  mixins: [BaseViewMixin, CustomerTabsMixin],
  components: {},
  async created() {
    this.initialize();
  },
  data() {
    return {
      toolbar: {
        edit: {
          tabIndex: -1,
          icon: "edit",
          visible: FeatureStorage.checkPermission("AgentCommission", "edit"),
          onClick: () => {
            this.$router.push({
              path: `/customer-agent/edit/${this.baseView.id}`,
            });
            this.$refs["header-form"].instance.repaint();
          },
        },
        save: {
          tabIndex: -1,
          icon: "floppy",
          validationGroup: "formsData",
          onClick: async (e) => {
            this.$logger.trackEventButtonClickSave();
            const result = await e.validationGroup.validate();
            if (result.isValid) {
              this.saveCustomerAgent();
            } else {
              this.addErrorMessagesFromValidationResult(result);
              this.displayValidationSummary();
            }
          },
        },
      },

      model: {
        CustomerCode: "",
        CustomerName: "",
        AgentCode: undefined,
        CommissionPcnt: 0,
        AgentName: "",
        IsNewAgent: true,
        AccrualAccount: "",
      },
    };
  },
  computed: {
    items() {
      return [
        {
          itemType: "group",
          caption: "",
          items: this.parseFormColumns([
            {
              dataField: "AgentCode",
              gcLabel: "Agent",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: AgentSupplierService.dataSourceConfig(
                  "api/AgentSupplier",
                  {}
                ),
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                showClearButton: true,
                itemTemplate: "agentTemplate",
                disabled: this.baseView.mode == "review",
              },
              required: true,
            },

            {
              dataField: "CommissionPcnt",
              gcType: "Decimal-6-4",
              gcLabel: "Commission %",
              disabled: this.baseView.mode == "review",
              validationRules: [
                {
                  type: "range",
                  message: "Commission is not between 0 and 100",
                  min: 0,
                  max: 100,
                },
              ],
            },
            {
              dataField: "AccrualAccount",
              gcLabel: "Accrual Account",
              gcType: "String",
              editorType: "dxSelectBox",
              editorOptions: {
                dataSource: GLChartService.dataSourceConfig2("api/GLChart", {
                  filter: ["Inactive", "=", "N"],
                  select: ["ComputedStringCode", "Description", "Code"],
                  key: "RecordId",
                }),
                valueExpr: "ComputedStringCode",
                displayExpr: "Description",
                searchExpr: ["ComputedStringCode", "Description"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                itemTemplate: "accrualAccountTemplate",
                disabled: this.baseView.mode == "review",
              },
              required: true,
            },
          ]),
        },
      ];
    },
  },
  methods: {
    async initialize() {
      await this.$store.dispatch("screenFactors/getFactors", [642]);

      let defaultCommission = this.getFactorByCode(642).Factorc;

      if (this.baseView.mode !== "create") {
        this.model.CustomerCode = this.baseView.id;
        await this.getCustomer().then((response) => {
          if (response.data.value.length > 0) {
            var customerFromApi = response.data.value[0];
            this.model.CustomerCode = customerFromApi.Code;
            this.model.CustomerName = customerFromApi.Name;
          }

          this.getCustomerAgent().then((response2) => {
            if (response2.data.value.length > 0) {
              var customerAgentFromApi = response2.data.value[0];
              this.model.AgentCode = customerAgentFromApi.AgentCode;
              this.model.CommissionPcnt = customerAgentFromApi.CommissionPcnt;
              this.model.AgentName = customerAgentFromApi.Supplier.Name;
              this.model.IsNewAgent = false;
              this.model.AccrualAccount =
                customerAgentFromApi.CommissionGLAccountCode.toString();
            } else {
              this.model.CommissionPcnt = parseFloat(defaultCommission || 0);
            }
          });
        });
      } else {
        this.model.CommissionPcnt = parseFloat(defaultCommission || 0);
      }
      this.toolbar.edit.visible = this.formsConfig.editableOption;
    },
    onFormContentReady(e) {
      validationEngine.validateGroup("formsData");
      if (e) {
        setTimeout(() => {
          e.component.instance().getEditor("AgentCode").focus();
        }, 100);
      }
    },

    async getCustomer() {
      return CustomerService.getByCode(this.baseView.id, ["Code", "Name"]);
    },
    async getCustomerAgent() {
      return CustomerAgentService.getByCustomerCode(this.baseView.id);
    },
    async saveCustomerAgent() {
      await CustomerAgentService.saveCustomerAgent(this.model.IsNewAgent, {
        AgentCode: this.model.AgentCode,
        CustomerCode: this.model.CustomerCode,
        CommissionPcnt: this.model.CommissionPcnt,
        CommissionGLAccountCode: this.model.AccrualAccount,
      })
        .then(() => {
          this.$notify("Customer Agent saved successfully", "success");
          this.initialize();
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/customer-agent/review/${this.baseView.id}`,
          });
        })
        .catch((error) => {
          this.displayServerError(error, "Customer Agent save failed");
        });
    },
    backButtonFunction() {
      this.$router.push({
        path: "/customer",
      });
    },
  },
  mounted() {
    this.selectedIndex = 4;
  },
  beforeMount() {},
};
</script>
